import React from "react";
import PropTypes from "prop-types";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  modal: {
    position: "absolute",
    top: theme.spacing(15),
    overflow: "hidden",
    borderRadius: 0,
  },

  modalTitle: {
    background: theme.palette.primary.main,
    color: "white",
  },

  modalAction: {
    padding: 0,
    "& button": {
      background: "#e5e2e2",
      borderRadius: 0,
      width: "100%",
      textTransform: "capitalize",
      height: "50px",
    },
  },
}));

const Modal = (props) => {
  const { modalFields, setModalFields } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={modalFields.isOpen} classes={{ paper: classes.modal }}>
      <Grid container>
        <Grid
          item
          xs={12}
          style={{ padding: "1px", backgroundColor: "#808080" }}
        >
          <DialogTitle
            className={t(classes.modalTitle)}
            style={{ textTransform: "capitalize" }}
          >
            <div>{t(modalFields.title)}</div>
          </DialogTitle>
        </Grid>

        <Grid item xs={12} style={{ border: "1px solid gray", borderTop: 0 }}>
          <DialogContent>{modalFields.body}</DialogContent>
          </Grid>   

          <Grid item xs={12}>
          <DialogActions className={classes.modalAction}>
            {modalFields.confirmButtonLabel ? (
              <Button
                onClick={modalFields.onConfirm}
                style={{ border: "1px solid gray" }}
              >
                {t(modalFields.confirmButtonLabel)}
              </Button>
            ) : null}
            <Button
              onClick={() => {
                setModalFields({ ...modalFields, isOpen: false });
                modalFields.resetModalBodyState();
              }}
              style={{ margin: 0, border: "1px solid gray" }}
            >
              {t("Cancel")}
            </Button>
          </DialogActions>
        </Grid>
      </Grid>
    </Dialog>
  );
};

Modal.propTypes = {
  modalFields: PropTypes.object,
  setModalFields: PropTypes.func,
};

export default Modal;
